import { render, staticRenderFns } from "./RatingsReviews.vue?vue&type=template&id=7f6ecedf&"
import script from "./RatingsReviews.vue?vue&type=script&lang=js&"
export * from "./RatingsReviews.vue?vue&type=script&lang=js&"
import style0 from "./RatingsReviews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports